import { SubscriptionPlan } from '@repo/graphql-types'
import type { SubscriptionType } from '@repo/graphql-types'

export const TEAM_MONTHLY_SUBSCRIPTION_TYPE: SubscriptionPlan.TeamMonthly =
  SubscriptionPlan.TeamMonthly

export type TeamSubscriptionType = SubscriptionPlan.TeamMonthly
export type PaymentSubscriptionType = SubscriptionType | TeamSubscriptionType

export function isTeamSubscriptionType(
  subscriptionType: PaymentSubscriptionType | string | null | undefined,
): subscriptionType is TeamSubscriptionType {
  return subscriptionType === TEAM_MONTHLY_SUBSCRIPTION_TYPE
}
